import React, { Component } from 'react';
import axios from "axios";
import config from "../config";
import i18n from "../i18n";
import ListingsView from "../views/ListingsView";

class ListingsController extends Component {
  constructor(props) {
    super(props);

    this.state = {
      animals: null
    };
  }

  componentDidMount() {
    this.getAnimals()
      .then(response => {
        this.setState({
          animals: response.data
        });
      });
  }

  async getAnimals() {
    return axios.get(config.endpoints.summary, {
      headers: {
        'Accept-Language': i18n.language
      }
    })
      .catch(error => {
        console.log(error);
      });
  }

  render() {
    return (
      <ListingsView
        {...this.props}
        {...this.state}
      />
    )
  }
}

export default ListingsController;
